import { createControlComponent } from "@react-leaflet/core";
import Locate from "leaflet.locatecontrol";
import { LuMapPin, LuLoader } from "react-icons/lu";
import LeafletReactIconControl from "./LeafletReactIconControl";

// Define custom classes that we will target for injection
const CUSTOM_ICON_CLASS = "leaflet-control-locate-custom-icon";
const CUSTOM_LOADING_CLASS = "leaflet-control-locate-custom-loading";

// Factory function for creating the Leaflet control instance
const createLocateInstance = (props) => {
    return new Locate({
        ...props,
        // Pass our custom classes. The library will create <span class="custom-class"></span>
        icon: CUSTOM_ICON_CLASS,
        iconLoading: CUSTOM_LOADING_CLASS
    });
};

// The React Component for the Leaflet Control
const LocateControlComponent = createControlComponent(createLocateInstance);

// Wrapper component to handle the DOM injection logic
const LocateControl = (props) => {
    return (
        <LeafletReactIconControl
            ControlComponent={LocateControlComponent}
            controlProps={props.options}
            iconClass={CUSTOM_ICON_CLASS}
            Icon={LuMapPin}
            loadingClass={CUSTOM_LOADING_CLASS}
            IconLoading={LuLoader}
            iconProps={{ size: 18}}
            containerStyle={{ color: "black" }}
        />
    );
};

export default LocateControl;